
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class FacultyDetail extends Vue {
    @Prop({ required: true }) public member;
  }
